/* @HEADER
 * @version 0.16.496 | 2026-08-10
 * @purpose Bounded data-testid registry for the EmojiPicker project-avatar popover — stable hooks for the hermetic staging multiplayer walkthrough's project-identity segment (ZVX-DEV-3520) to change and read back a project's avatar.
 * @sidecar emoji-picker.testids.ts.header.md
 * @layer app | @hex _none_ | @ctx _none_
 * @public true
 * @edit careful
 */

// SpecRefs: ZVX-DEV-3520

/** Bounded testid registry for the EmojiPicker (project logo/avatar popover). */
export const EMOJI_PICKER_TESTIDS = {
  /** Root of the popover — presence proves it is open. */
  popover: 'emoji-picker-popover',
  /** One color-preset swatch button; disambiguate via `data-color={hex}`. */
  colorSwatch: 'emoji-picker-color-swatch',
  /** One emoji grid button; disambiguate via `data-emoji={char}`. */
  emojiButton: 'emoji-picker-emoji-btn',
  /** Hidden `<input type="file">` for the "Загрузить" custom-image avatar. */
  uploadInput: 'emoji-picker-upload-input',
  /** "✕ Убрать" button — clears the current icon back to the initial letter. */
  clearBtn: 'emoji-picker-clear-btn',
  /** ZVX-DEV-3630: inline notice shown when the uploaded image exceeds the
   *  size limit — replaces the native alert() that used to report it. */
  uploadTooLargeNotice: 'emoji-picker-upload-too-large-notice',
} as const;
